import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import ChooseDeliveryOptions from "../components/scheduleDelivery/ChooseDeliveryOptions";

export default function DeliveryOptionView() {
	return (
		<div className="pageWrapper">
			<Header title="Bezorgkeuze maken" />
			<div className="contentWrapper fadeInDelayed">
				<ChooseDeliveryOptions />
			</div>
			<BottomNavBar />
		</div>
	);
}
